import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arr-side-left",
  "use": "arr-side-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arr-side-left\"><path d=\"M10.748 3.529a.667.667 0 0 0-.943 0L5.333 8l4.472 4.471a.667.667 0 0 0 .943-.942L7.219 8l3.529-3.529a.667.667 0 0 0 0-.942Z\" fill=\"#3B3F3D\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol